module.exports = __webpack_public_path__ + "img/bg2.b9f059a6.png";